// client/src/components/modals/EditCustomerModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap';
import api from '../../api/axios'; // Use centralized api instance

const EditCustomerModal = ({ show, onHide, customer, onSuccess }) => {
    const isEditing = !!customer;
    const [formData, setFormData] = useState({
        customerName: '',
        phoneNumber: '',
        comment: ''
    });
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            if (isEditing) {
                setFormData({
                    customerName: customer.customerName || '',
                    phoneNumber: customer.phoneNumber || '',
                    comment: customer.comment || ''
                });
            } else {
                setFormData({ customerName: '', phoneNumber: '', comment: '' });
            }
        }
    }, [customer, isEditing, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setError('');
        if (!formData.customerName) {
            setError('고객 이름은 필수입니다.');
            return;
        }
        
        setIsSaving(true);
        try {
            if (isEditing) {
                await api.put(`/customers/${customer.id}`, formData);
            } else {
                await api.post('/customers', formData);
            }
            onSuccess();
            onHide();
        } catch (err) {
            const message = err.response?.data?.error || '저장에 실패했습니다.';
            setError(message);
            console.error("Failed to save customer:", err);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isEditing ? '고객 정보 수정' : '신규 고객 등록'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>고객명</Form.Label>
                        <Form.Control
                            type="text"
                            name="customerName"
                            value={formData.customerName}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>연락처</Form.Label>
                        <Form.Control
                            type="text"
                            name="phoneNumber"
                            placeholder="예: 010-1234-5678"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>코멘트</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="comment"
                            value={formData.comment}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    취소
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={isSaving}>
                    {isSaving ? <Spinner as="span" size="sm" /> : '저장'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCustomerModal;
